import Vue from 'vue'
import VueRouter from 'vue-router'
const isServer = process.env.VUE_ENV === 'server'

if (!isServer) {
  // fix NavigationDuplicated: Avoided redundant navigation to current location 报错
  const fns = ['push', 'replace']
  fns.forEach(v => {
    const originalFn = VueRouter.prototype[v]
    VueRouter.prototype[v] = function (location) {
      return originalFn.call(this, location).catch(err => err)
    }
  })
}

const notFound = () =>
  import(/* webpackChunkName: "notFound" */ 'page/notFound.vue')
// import pageMixin from '../mixins/page'
// import consultPageMixin from 'mixins/consult/page'

import consult from './consult/index'
import consultText from './consultText/index.js'
import qingsu from './qingsu/index.js'
import supervision from './supervision/index.js'
import xlt from './xlt/index'
import orgProtocol from './orgProtocol/index'

// import mixinRoute from 'app/web/utils/mixinRoute.js'

Vue.use(VueRouter)

let routes = [
  ...qingsu,
  ...consult,
  ...consultText,
  ...supervision,
  ...xlt,
  ...orgProtocol,
  {
    path: '*',
    component: notFound,
    name: '404'
  }
]

export default function createRouter() {
  return new VueRouter({
    mode: 'history',
    base: '/',
    routes: routes // mixinRoute(routes, [pageMixin])
  })
}
